//
//
// Update Lesson Docker
// This is a wrapper that updates docker.
// All the logic is inside of AddLesson Dock
//
//
import { createConfirmation } from 'react-confirm'
import DockBody, { UPDATE } from "template/Docks/AddLesson/DockBody";
import Lesson from 'mediators/Lesson'
import ClassDetail from 'mediators/ClassDetail';

const modal = createConfirmation(DockBody);

export default function (opts = {}) {
  opts.mode = UPDATE;
  // if there is no opts.classDetail, there should be at least classId to load it!
  if (!opts.classDetail && !opts.classId) {
    throw new Error('While opts.classDetail is missing, opts.classId is also missing which is needed to fetch classDetail');
  } 
  
  if (opts.classDetail) {
    opts.classDetail = new ClassDetail(opts.classDetail);
  }

  console.log(opts.lesson);

  if (opts.lesson) {
    opts.lesson = new Lesson(opts.lesson);
  }

  opts.chooseClass = false;
  return modal(opts);
}




// WEBPACK FOOTER //
// ./src/template/Docks/UpdateLesson/index.js